// 短視頻 左右滑動
import VideoBox from 'component/VideoBoxVertical'
import { memo, useCallback, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Wrapper } from './Styled'
import EffectFlat from 'swiperEffects/cardFlat'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver'
import { useDuplicatedArray } from 'hooks/useDuplicatedArray'
import { AreaBoxSwiperTemplateWrapper, MaskedBase64Background } from '../Styled'

interface Template15Props {
  videoData: any[]
}

function Template15({ videoData: videoDataProp }: Template15Props) {
  const videoData = useDuplicatedArray(videoDataProp, 5)

  const [currentSlide, setCurrentSlide] = useState(0)

  const currentItem: any = videoData[currentSlide]

  const currentImage = currentItem?.coverphoto_v

  const onSlideChange = useCallback((swiper: any) => {
    setCurrentSlide(swiper.realIndex)
  }, [])

  const { ref, visible } = useIntersectionObserver<HTMLDivElement>({
    /* Optional options */
    defaultVisible: false,
    threshold: 0,
    triggerOnce: false,
  })

  return (
    <AreaBoxSwiperTemplateWrapper>
      <Wrapper ref={ref}>
        <MaskedBase64Background className={'swiper-no-swiping'} src={currentImage} noLazy={visible} allowUnload />
        <Swiper
          centeredSlides={true}
          slidesPerView={2}
          spaceBetween={30}
          effect="flat"
          onSlideChange={onSlideChange}
          modules={[EffectFlat]}
          flatEffect={{
            depth: 300,
          }}
          loop={true}
          nested={true}
        >
          {videoData?.map((item, i) => {
            return (
              <SwiperSlide key={i} style={{ width: '4.7rem' }}>
                <VideoBox
                  overflow={true}
                  textAlign="center"
                  videoInfo={item}
                  width="auto"
                  noLazy={visible}
                  allowUnload
                />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </Wrapper>
    </AreaBoxSwiperTemplateWrapper>
  )
}
export default memo(Template15)
